document.addEventListener("DOMContentLoaded", function () {

    $(".counter").each(function () {
        var number = $(this).text();
        var numberCount = parseFloat(number.replace(/[^0-9.\-]/g, ""));
        var numberCountString = numberCount.toString();
        var numberWidth = $(this).width() + 25;

        $(this).html(numberCount).width(numberWidth);

        if ($(this).hasClass("counter-slow")) {
            var durationSpeed = 4000;
        } else if ($(this).hasClass("counter-fast")) {
            var durationSpeed = 1000;
        } else {
            var durationSpeed = 2000;
        }

        if (numberCount !== Math.floor(numberCount)) {
            var decimalCount = parseInt(numberCountString.length - numberCountString.indexOf(".") - 1);
            $(this).countimator({
                max: numberCount,
                decimals: decimalCount,
                duration: durationSpeed,
            });
        } else {
            $(this).countimator({
                max: numberCount,
                thousandDelimiter: ",",
                duration: durationSpeed,
            });
        }

        function is_numeric(str) {
            return /^\d+$/.test(str);
        }

        if (!is_numeric(number.charAt(0))) {
            var preContent = number.replace(/[0-9.\-]/g, "");
            $(this).attr("data-pre-content", preContent);
        } else {
            var postContent = number.replace(/[0-9.\-]/g, "");
            $(this).attr("data-post-content", postContent);
        }
    });



    function handleScroll() {
        const scrolledToElements = document.querySelectorAll(".scrolled-to");
        scrolledToElements.forEach((element) => {
            const elementTop = element.getBoundingClientRect().top;
            const elementBottom = element.getBoundingClientRect().bottom;
            const windowHeight = window.innerHeight;
            // Offset the "in view" functionality so the element triggers before or after it is actually in view
            if (elementTop < windowHeight + 0 && elementBottom >= + 100) {
                element.classList.add("animated");
            }
        });
    }handleScroll();
    window.addEventListener("scroll", handleScroll);



	function iconAnimation() {
        const iconAnimationWrapper = document.querySelector(".icon-animation");
        if(iconAnimationWrapper) {
            const iconCount = iconAnimationWrapper.getAttribute("data-icon-count");
            const iconCountTo = iconAnimationWrapper.getAttribute("data-icon-count-to");
            const iconAnimationSpeed = iconAnimationWrapper.getAttribute("data-animation-speed");
            const imgSRC = iconAnimationWrapper.querySelector("img").getAttribute("src");
            const imgALT = iconAnimationWrapper.querySelector("img").getAttribute("alt");
            const imgWidth = iconAnimationWrapper.querySelector("img").getAttribute("width");
    
            for (let i = 1; i < iconCount; i++) {
                const img = document.createElement("img");
                img.src = imgSRC;
                img.alt = imgALT;
                img.style.width = imgWidth;
                iconAnimationWrapper.appendChild(img);
            }
    
            const images = iconAnimationWrapper.querySelectorAll("img");
            images.forEach((image, index) => {
                if (index < iconCountTo) {
                    setTimeout(() => {
                        image.classList.add("highlight");
                    }, index * iconAnimationSpeed);
                }
            });
        }
    }iconAnimation();


    
	function makeCircular() {
        const circularElements = document.querySelectorAll('.circle');
        circularElements.forEach(element => {
            const width = element.offsetWidth;
            element.style.height = `${width}px`;
        });
    }makeCircular();



    function revealMain() {
        const main = document.querySelector('main');
        main.classList.remove('loading');
    }
    window.addEventListener('load', revealMain);
});